import React from "react";
import { CoursesDropdown } from "../CoursesDropdown/CoursesDropdown";
import { TeachersDropdown } from "../TeachersDropdown/TeachersDropdown";
import { ReactComponent as HalfCircleICon } from "../../../assets/icons/filter/half-circle-svgrepo-com.svg";
import { DatePick } from "../FilterComponents/DatePicker/DatePicker";
import FilterByDropdown from "../FilterByDropdown/FilterByDropdown";
import DaysFilter from "../DaysFilter/DaysFilter";
import Search from "../Search/Search";
import { ReactComponent as PlusIcon } from "../../../assets/icons/Plus.svg";
import GroupTypeDropdown from "../GroupTypeDropdown/GroupTypeDropdown";

const GroupsPageHead = ({
  filter,
  count,
  searchData,
  dataSearchValues,
  DATA_SEARCH_VALUE,
  openModal,
}) => {
  return (
    <div className="groups-filter-header">
      <div className="groups-all-filter-container">
        <div className="groups-filter-detail-header">
          <button className="add-detail" onClick={openModal}>
            <PlusIcon />
            Əlavə et
          </button>
        </div>
        {/* <div className="groups-filter-container"> */}
        <div className="groups-filter-top-container">
          <Search
            searchData={searchData}
            dataSearchValues={dataSearchValues}
            className="search-input-con desktop"
            DATA_SEARCH_VALUE={DATA_SEARCH_VALUE}
          />
          <CoursesDropdown deviceType="desktop" />
          <TeachersDropdown deviceType="desktop" />
          <GroupTypeDropdown deviceType="desktop" />
          <FilterByDropdown deviceType="desktop" />
        </div>
        <div className="groups-filter-bottom-container">
          <DatePick deviceType="desktop" />
          <DaysFilter deviceType="desktop" />
          <div className="lesson-table-btn-container groups ">
            <button className="add-detail" onClick={() => filter()}>
              Tətbiq et
            </button>
          </div>
          <div className="circle-icon">
            <p className="filter-count">{count}</p>
            <HalfCircleICon />
          </div>
        </div>
      </div>
    </div>
  );
};

export default GroupsPageHead;
